// extracted by mini-css-extract-plugin
export default {"ChatActions":"ChatActions_ChatActions__wHvAS","ActionsContainer":"ChatActions_ActionsContainer__zl5E7","ActionButton":"ChatActions_ActionButton__MTpIZ"};